import React from 'react';

// A small TypeScript/JavaScript highlighter: comments, strings, keywords, numbers, and the
// PulseScript API names. Enough for the snippets on this page; no dependency.
const KW = new Set('import from const let var function return if else for of in while new interface type class extends await async true false null undefined typeof this break continue export default'.split(' '));
const API = new Set('root stage Shape Sprite MovieClip Symbol TextField GlowFilter MouseEvent KeyboardEvent Event AudioEvent Tween Timer random armature Pulse trace'.split(' '));
const RE = /(\/\/[^\n]*|\/\*[\s\S]*?\*\/)|(`(?:\\.|[^`])*`|'(?:\\.|[^'\n])*'|"(?:\\.|[^"\n])*")|(\b\d+(?:\.\d+)?\b)|([A-Za-z_$][\w$]*)/g;

export function highlight(src) {
  const out = [];
  let last = 0, m, k = 0;
  RE.lastIndex = 0;
  while ((m = RE.exec(src))) {
    if (m.index > last) out.push(src.slice(last, m.index));
    const [tok, com, str, num, id] = m;
    if (com) out.push(<span key={k++} className="tk-c">{tok}</span>);
    else if (str) out.push(<span key={k++} className="tk-s">{tok}</span>);
    else if (num) out.push(<span key={k++} className="tk-n">{tok}</span>);
    else if (id && KW.has(id)) out.push(<span key={k++} className="tk-k">{tok}</span>);
    else if (id && API.has(id)) out.push(<span key={k++} className="tk-a">{tok}</span>);
    else out.push(tok);
    last = m.index + tok.length;
  }
  if (last < src.length) out.push(src.slice(last));
  return out;
}

export default function Code({ children, label, className = '' }) {
  return (
    <pre className={`wx-code code ${className}`} tabIndex={0} aria-label={label}>
      <code>{highlight(String(children))}</code>
    </pre>
  );
}
